import React from 'react';
import PropTypes from 'prop-types';
import { ParticipantPill } from '@medflex/components/stories/Sessions/SessionsListItem';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import getParticipantsWithoutOrganizer from '../../../utils/getParticipantsWithoutOrganizer';
import useUserProfile from '../../hooks/useUserProfile';
import useAddressBookContacts from '../../hooks/useAddressBookContacts';

const getOneAttendee = (userId, participants = []) => {
  const attendees = participants.filter(({ roles }) => !(roles && roles.includes('moderator')));
  if (attendees.length === 1) return attendees[0];
  return attendees.find(p => p.userId !== userId) || {};
};

const Participants = ({ items }) => {
  const { userProfile } = useUserProfile();
  const filteredItems = getParticipantsWithoutOrganizer(items);
  const { userId, firstName, lastName } = getOneAttendee(userProfile.id, filteredItems);
  const { findOneAddressBookContactByUserId } = useAddressBookContacts();

  const url =
    (userId &&
      findOneAddressBookContactByUserId(userId)?.id &&
      `/chat/${findOneAddressBookContactByUserId(userId).id}`) ||
    null;

  return (
    <ParticipantPill
      items={[getFullNameWithTitle({ userId, firstName, lastName })]}
      remaining={filteredItems.length > 2 ? filteredItems.length - 1 : 0}
      url={url}
    />
  );
};

Participants.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ roles: PropTypes.arrayOf(PropTypes.oneOf(['moderator', 'organizer'])) }),
  ),
};

export default Participants;
